export const TrCheckboxWithMessage = (props) => {
    const {message, isAlert, onChange} = props;
    const normalCss = "bg-white";
    const alertCss = "bg-red-200"; 
    return (
        <>
            <tr><td><label className={!isAlert ? normalCss : alertCss}><input type="checkbox" id="identification" onChange={onChange}/><span>{message}</span></label></td></tr>
        </>
    );
};